<template>
  <div class="tab-pane" v-show="show">
    <slot></slot>
  </div>
</template>
<script>
import { inject, toRefs } from 'vue'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup (props, { attrs }) {
    const addTab = inject('addTab')
    const tab = addTab(props.title, props.active, attrs?.id)

    return toRefs(tab)
  }
}
</script>
